import { useEffect, useState } from "react";
import { Button, Input, Modal, SreenCoverLoading } from "src/components";
import styled from "styled-components";
import copyToClipboard from "src/utils/copyToClipboard";
import { useParams } from "react-router-dom";
import { useAlert } from "src/hooks";
import { createTeeshotAxiosInstance } from "src/http";
// import { useModal, useModalState } from "src/context/ModalContext";
import { TbCopy } from "react-icons/tb";
import { useRecoilState } from "recoil";
import { recoilStates } from "../recoil/recoilStates";
import backgroundImage from "src/assets/images/groupjoin.png";
export default function LoadApp() {
  const [_, setInit] = useRecoilState(recoilStates.init);
  useEffect(() => {
    setInit({ isInit: true });
  }, []);

  const params = useParams();
  const [isModalOpened, setIsModalOpened] = useState(false);
  function openApp() {
    var appLink = "teeshotapp://teeshot/yearBooking"; // 앱 딥 링크
    var storeLink = "https://play.google.com/store/apps/details?id=kr.co.teeshot.app"; // Play Store 링크
    var now = new Date().getTime();

    // 1. 앱 실행 시도 (숨겨진 iframe 사용)
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = appLink;
    document.body.appendChild(iframe);

    // 2. 일정 시간 후 앱이 실행되지 않았으면 스토어로 이동
    setTimeout(function () {
      var elapsed = new Date().getTime() - now;
      if (elapsed < 3000) {
        // 앱이 실행되지 않은 경우 (사용자가 페이지를 떠나지 않음)
        window.location.href = storeLink;
      }
    }, 3000); // 타임아웃 1.5초 (환경에 따라 조정 가능)

    // 3. iframe 제거
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 3000);
  }

  const {
    value: nameValue,
    onChange: handleNameChange,
    resetValue: resetName,
  } = Input.hooks.useInput();
  const {
    value: contactValue,
    onChange: handleContactChange,
    resetValue: resetContact,
  } = Input.hooks.useInput("");
  const [groupData, setGroupData] = useState<any>(null);
  useEffect(() => {
    (async () => {
      const res = await createTeeshotAxiosInstance().get(
        `/yearBooking/outMember/group?groupCode=${params.groupCode}`
      );

      if (!res.data?.success) {
        alert("조회실패");
        return;
      }
      setIsLoading(false);
      setGroupData(res.data.data.group);
      return;
    })();
  }, []);

  const alert = useAlert();
  const [isLoading, setIsLoading] = useState(true);

  if (!isLoading && !groupData) {
    return <>존재하지 않는 그룹</>;
  }
  return (
    <Container>
      <ContentWrapper>
        <TitleSection>
          <GroupName>'{groupData?.name}'</GroupName>
          <Subtitle>지금 멤버로 합류해보세요.</Subtitle>
        </TitleSection>

        <CodeCard>
          <CodeImage src={backgroundImage} alt="초대 이미지" />
          <CodeText>{params.groupCode}</CodeText>
          <CopyButton
            onClick={() => {
              (async () => {
                await copyToClipboard(params.groupCode || "");
                alert("초대코드가 복사되었습니다.");
              })();
            }}
          >
            <TbCopy />
            초대코드 복사
          </CopyButton>
        </CodeCard>
      </ContentWrapper>

      <ButtonSection>
        <Button
          $buttonSize="md"
          $colorTheme="green"
          $round
          onClick={() => {
            (async () => {
              await copyToClipboard(params.groupCode || "오류");
              openApp();
            })();
          }}
        >
          티샷 앱에서 참여
        </Button>

        <Button
          $buttonSize="md"
          $colorTheme="white"
          $round
          $outline
          onClick={() => {
            setIsModalOpened(true);
          }}
        >
          휴대폰 번호만 전달
        </Button>
      </ButtonSection>

      {isLoading && <SreenCoverLoading />}
      {isModalOpened && (
        <>
          <Modal
            onConfirm={() => {
              if (!contactValue || !nameValue) {
                alert({
                  content: "이름과 전화번호를 입력해주세요",
                  onClose: () => {
                    setIsModalOpened(true);
                  },
                });
                return;
              }
              (async () => {
                setIsLoading(true);
                try {
                  const res = await createTeeshotAxiosInstance().post("/yearBooking/outMember", {
                    submitData: {
                      groupCode: params.groupCode,
                      name: nameValue,
                      contact: contactValue,
                    },
                  });
                  if (!res.data.success) {
                    throw new Error(res.data?.message || "서버오류발생");
                  }
                  alert("총무님에게 전화번호를 성공적으로 전달했습니다.");
                } catch (e: any) {
                  console.log("e :", e);
                  alert(e?.message || "오류발생");
                } finally {
                  setIsLoading(false);
                }
              })();
            }}
            content={
              <ModalBox className="d-flex fd-c gap-3">
                <div className="d-flex fd-c gap-1">
                  <p>전화번호를 총무님께 전달해주세요.</p>
                  <p>추후 라운드 일정 및 라커번호를 안내해드립니다.</p>
                </div>
                <div>그룹코드: {params.groupCode}</div>
                <div className="d-flex fd-c gap-1">
                  <Input
                    attr={{
                      value: nameValue,
                      onChange: handleNameChange,
                      placeholder: "예시) 홍길동",
                    }}
                  />
                  <Input
                    attr={{
                      value: contactValue,
                      onChange: handleContactChange,
                      placeholder: "예시) 01012345678",
                      type: "number",
                    }}
                  />
                </div>
              </ModalBox>
            }
            setModalState={setIsModalOpened}
          />
        </>
      )}
    </Container>
  );
}

const ModalBox = styled.div``;

const TitleSection = styled.div`
  text-align: center;
`;

const GroupName = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #000;
  margin-bottom: 8px;
`;

const Subtitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #000;
`;

const CodeCard = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 30px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const CodeImage = styled.img`
  width: 100%;
  max-width: 300px;
  height: auto;
  border-radius: 8px;
`;

const CodeText = styled.div`
  font-size: 32px;
  font-weight: bold;
  color: #000;
  letter-spacing: 2px;
`;

const CopyButton = styled.button`
  background-color: #1a1a1a;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056cc;
  }

  svg {
    font-size: 18px;
  }
`;

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
`;

const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: auto;
`;

const Chil = (props: { zz: any }) => {
  // console.log(props.zz);

  useEffect(() => {
    // console.log(" 나: load");
  }, []);

  return <div>나나</div>;
};

function nodeScriptReplace(node: any) {
  if (nodeScriptIs(node) === true) {
    node.parentNode.replaceChild(nodeScriptClone(node), node);
  } else {
    var i = -1,
      children = node.childNodes;
    while (++i < children.length) {
      nodeScriptReplace(children[i]);
    }
  }

  return node;
}
function nodeScriptClone(node: any) {
  var script = document.createElement("script");
  script.text = node.innerHTML;

  var i = -1,
    attrs = node.attributes,
    attr;
  while (++i < attrs.length) {
    script.setAttribute((attr = attrs[i]).name, attr.value);
  }
  return script;
}

function nodeScriptIs(node: any) {
  return node.tagName === "SCRIPT";
}
